var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "card" }, [
    _c("div", { staticClass: "card-body" }, [
      _c("h3", { staticClass: "text-center py-3" }, [
        _vm._v("\n      " + _vm._s(_vm.textData.quotationTitle) + "\n    ")
      ]),
      _vm._v(" "),
      _vm.serviceId === 16
        ? _c("section", { staticClass: "mt-4" }, [
            _c("label", [_vm._v(_vm._s(_vm.$t("message.terms_of_service")))]),
            _vm._v(" "),
            _c("ul", { staticClass: "list-unstyled" }, [
              _c("li", [
                _vm._m(0),
                _vm._v(
                  "\n          " +
                    _vm._s(
                      _vm.$t(
                        "message.service_request.ac_cleaning_service_condition01"
                      )
                    ) +
                    "\n        "
                )
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._m(1),
                _vm._v(
                  "\n          " +
                    _vm._s(
                      _vm.$t(
                        "message.service_request.ac_cleaning_service_condition02"
                      )
                    ) +
                    "\n        "
                )
              ])
            ]),
            _vm._v(" "),
            _c("hr")
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.serviceId === 13 || _vm.serviceId == 24
        ? _c("section", { staticClass: "mt-4" }, [
            _c("label", [_vm._v(_vm._s(_vm.$t("message.terms_of_service")))]),
            _vm._v(" "),
            _c("ul", { staticClass: "list-unstyled" }, [
              _c("li", [
                _vm._m(2),
                _vm._v(
                  "\n          " +
                    _vm._s(
                      _vm.serviceId === 13
                        ? _vm.$t(
                            "message.service_request.big_cleaning_service_condition01"
                          )
                        : _vm.$t(
                            "message.service_request.disinfectant_cleaning_service_condition01"
                          )
                    ) +
                    "\n        "
                )
              ])
            ]),
            _vm._v(" "),
            _c("hr")
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("label", [
        _vm._v(
          "\n      " +
            _vm._s(_vm.$t("message.service_request.contact_information")) +
            "\n      "
        ),
        _c("span", { staticClass: "text-danger" }, [_vm._v("*")])
      ]),
      _vm._v(" "),
      !_vm.isEditing
        ? _c("section", [
            _c("div", { staticClass: "card shadow-sm" }, [
              _c("div", { staticClass: "card-body" }, [
                _c("ul", { staticClass: "list-unstyled" }, [
                  _c("li", { staticClass: "mb-2" }, [
                    _c("strong", [_vm._v(_vm._s(_vm.contactData.name))])
                  ]),
                  _vm._v(" "),
                  _c("li", { staticClass: "mb-2" }, [
                    _vm._v(_vm._s(_vm.contactData.email))
                  ]),
                  _vm._v(" "),
                  _c("li", { staticClass: "mb-2" }, [
                    _vm._v(_vm._s(_vm.contactData.tel))
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "mt-2" }, [
                  _c(
                    "a",
                    {
                      staticClass: "text-primary-link",
                      attrs: { href: "" },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          _vm.isEditing = true
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n              " +
                          _vm._s(
                            _vm.$t("message.booking.checkout_step.edit_data")
                          ) +
                          "\n            "
                      )
                    ]
                  )
                ])
              ])
            ])
          ])
        : _c("section", { staticClass: "mt-2" }, [
            _c("div", { staticClass: "form-group" }, [
              _c("label", { attrs: { for: "name" } }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("message.big_cleaning.contact_name")) +
                    "\n          "
                ),
                _c("span", { staticClass: "text-danger" }, [_vm._v("*")])
              ]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.contactData.name,
                    expression: "contactData.name"
                  },
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'"
                  }
                ],
                ref: "name",
                staticClass: "form-control input-jumbo",
                attrs: { type: "text", name: "name", id: "name" },
                domProps: { value: _vm.contactData.name },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.contactData, "name", $event.target.value)
                  }
                }
              }),
              _vm._v(" "),
              _vm.errors.has("name")
                ? _c("div", { staticClass: "mt-2 text-remark -status-alert" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("message.required_field")) +
                        "\n        "
                    )
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group" }, [
              _c("label", { attrs: { for: "email" } }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("message.big_cleaning.contact_email")) +
                    "\n          "
                ),
                _c("span", { staticClass: "text-danger" }, [_vm._v("*")])
              ]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.contactData.email,
                    expression: "contactData.email"
                  },
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'"
                  }
                ],
                ref: "email",
                staticClass: "form-control input-jumbo",
                attrs: { type: "email", name: "email", id: "email" },
                domProps: { value: _vm.contactData.email },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.contactData, "email", $event.target.value)
                  }
                }
              }),
              _vm._v(" "),
              _vm.errors.has("email")
                ? _c("div", { staticClass: "mt-2 text-remark -status-alert" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("message.required_field")) +
                        "\n        "
                    )
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group" }, [
              _c("label", { attrs: { for: "tel" } }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("message.big_cleaning.contact_tel")) +
                    "\n          "
                ),
                _c("span", { staticClass: "text-danger" }, [_vm._v("*")])
              ]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.contactData.tel,
                    expression: "contactData.tel"
                  },
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: {
                      required: true,
                      min: 10,
                      max: 15,
                      regex: /^\+?[0-9-]+$/
                    },
                    expression:
                      "{ required: true, min: 10, max: 15, regex: /^\\+?[0-9-]+$/ }"
                  }
                ],
                ref: "tel",
                staticClass: "form-control input-jumbo",
                attrs: { type: "tel", name: "tel", id: "tel" },
                domProps: { value: _vm.contactData.tel },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.contactData, "tel", $event.target.value)
                  }
                }
              }),
              _vm._v(" "),
              _vm.errors.has("tel")
                ? _c("div", { staticClass: "mt-2 text-remark -status-alert" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("message.required_field")) +
                        "\n        "
                    )
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-info",
                on: { click: _vm.checkContactData }
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("message.button.save")) +
                    "\n      "
                )
              ]
            )
          ]),
      _vm._v(" "),
      _vm.serviceId === 13
        ? _c("div", { staticClass: "form-group mt-4" }, [
            _c("label", [
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm.$t("message.service_request.big_cleaning_purpose")
                  ) +
                  "\n        "
              ),
              _c("span", { staticClass: "text-danger" }, [_vm._v("*")])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "select-jumbo" }, [
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.contactData.serviceRequestPurposeId,
                      expression: "contactData.serviceRequestPurposeId"
                    }
                  ],
                  on: {
                    change: function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.$set(
                        _vm.contactData,
                        "serviceRequestPurposeId",
                        $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      )
                    }
                  }
                },
                [
                  _vm._l(
                    _vm.globalState.configData.big_cleaning_types,
                    function(data) {
                      return [
                        _c("option", { domProps: { value: data.id } }, [
                          _vm._v(_vm._s(_vm._f("multiLangName")(data)))
                        ])
                      ]
                    }
                  )
                ],
                2
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.serviceId === 13
        ? _c("div", { staticClass: "row mt-4" }, [
            _c("div", { staticClass: "col-12 p-0" }, [
              _c("label", [
                _vm._v(
                  "\n          " +
                    _vm._s(
                      _vm.$t(
                        "message.service_request.big_cleaning_service_date"
                      )
                    ) +
                    "\n          "
                ),
                _c("span", { staticClass: "text-danger" }, [_vm._v("*")])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-6 p-0" }, [
              _c("div", { staticClass: "form-group mr-2" }, [
                _c("input", {
                  directives: [
                    {
                      name: "pikadayBooking",
                      rawName: "v-pikadayBooking",
                      value: _vm.calendarData,
                      expression: "calendarData"
                    },
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required",
                      expression: "'required'"
                    }
                  ],
                  ref: "cleaningDate",
                  staticClass: "form-control -date-picker input-jumbo",
                  attrs: {
                    type: "text",
                    name: "serviceDate",
                    placeholder: _vm.$i18n.t(
                      "message.booking.booking_step.date"
                    ),
                    readonly: ""
                  }
                }),
                _vm._v(" "),
                _c("span", {
                  staticClass: "far fa-calendar-alt input-text-icon"
                }),
                _vm._v(" "),
                _vm.errors.has("serviceDate")
                  ? _c(
                      "div",
                      { staticClass: "mt-2 text-remark -status-alert" },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("message.required_field")) +
                            "\n          "
                        )
                      ]
                    )
                  : _vm._e()
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-6 p-0" }, [
              _c("div", { staticClass: "form-group ml-2" }, [
                _c("div", { staticClass: "select-jumbo" }, [
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.contactData.serviceTime,
                          expression: "contactData.serviceTime"
                        }
                      ],
                      staticStyle: { background: "white" },
                      on: {
                        change: function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.$set(
                            _vm.contactData,
                            "serviceTime",
                            $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          )
                        }
                      }
                    },
                    _vm._l(_vm.globalState.arrTimes, function(time) {
                      return _c("option", { domProps: { value: time } }, [
                        _vm._v(_vm._s(time))
                      ])
                    }),
                    0
                  ),
                  _vm._v(" "),
                  _c("span", { staticClass: "far fa-clock input-text-icon" })
                ])
              ])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "form-group mt-4" }, [
        _c("label", [
          _vm._v("\n        " + _vm._s(_vm.textData.labelType) + "\n        "),
          _c("span", { staticClass: "text-danger" }, [_vm._v("*")])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "select-jumbo" }, [
          _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.contactData.buildingTypeId,
                  expression: "contactData.buildingTypeId"
                },
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: "required",
                  expression: "'required'"
                }
              ],
              class: { "form-alert": _vm.errors.has("buildingType") },
              attrs: { name: "buildingType" },
              on: {
                change: function($event) {
                  var $$selectedVal = Array.prototype.filter
                    .call($event.target.options, function(o) {
                      return o.selected
                    })
                    .map(function(o) {
                      var val = "_value" in o ? o._value : o.value
                      return val
                    })
                  _vm.$set(
                    _vm.contactData,
                    "buildingTypeId",
                    $event.target.multiple ? $$selectedVal : $$selectedVal[0]
                  )
                }
              }
            },
            [
              _c("option", { domProps: { value: null } }, [
                _vm._v(
                  _vm._s(
                    _vm.$t(
                      "message.service_request.big_cleaning_building_type_require"
                    )
                  )
                )
              ]),
              _vm._v(" "),
              _vm._l(_vm.dataTypes, function(data) {
                return [
                  _c("option", { domProps: { value: data.id } }, [
                    _vm._v(_vm._s(_vm._f("multiLangName")(data)))
                  ])
                ]
              })
            ],
            2
          ),
          _vm._v(" "),
          _vm.errors.has("buildingType")
            ? _c("div", { staticClass: "mt-2 text-remark -status-alert" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("message.required_field")) +
                    "\n        "
                )
              ])
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group" }, [
        _c("label", { attrs: { for: "buildingSize" } }, [
          _vm._v("\n        " + _vm._s(_vm.textData.labelSize) + "\n        "),
          _c("span", { staticClass: "text-danger" }, [_vm._v("*")])
        ]),
        _vm._v(" "),
        _vm.serviceId === 13
          ? _c("div", { staticClass: "text-remark mb-2" }, [
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm.$t(
                      "message.service_request.big_cleaning_building_size_remark"
                    )
                  ) +
                  "\n      "
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.contactData.buildingSize,
              expression: "contactData.buildingSize"
            },
            {
              name: "validate",
              rawName: "v-validate",
              value: "required",
              expression: "'required'"
            }
          ],
          staticClass: "form-control input-jumbo",
          class: { "form-alert": _vm.errors.has("buildingSize") },
          attrs: {
            type: "text",
            name: "buildingSize",
            id: "buildingSize",
            placeholder: _vm.textData.hintSize
          },
          domProps: { value: _vm.contactData.buildingSize },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.contactData, "buildingSize", $event.target.value)
            }
          }
        }),
        _vm._v(" "),
        _vm.errors.has("buildingSize")
          ? _c("div", { staticClass: "mt-2 text-remark -status-alert" }, [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.$t("message.required_field")) +
                  "\n      "
              )
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group" }, [
        _c("label", { attrs: { for: "buildingAddress" } }, [
          _vm._v(
            "\n        " +
              _vm._s(
                _vm.$t("message.service_request.big_cleaning_building_address")
              ) +
              "\n        "
          ),
          _c("span", { staticClass: "text-danger" }, [_vm._v("*")])
        ]),
        _vm._v(" "),
        _c("textarea", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.contactData.buildingAddress,
              expression: "contactData.buildingAddress"
            },
            {
              name: "validate",
              rawName: "v-validate",
              value: "required",
              expression: "'required'"
            }
          ],
          ref: "buildingAddress",
          staticClass: "form-control textarea-jumbo",
          class: { "form-alert": _vm.errors.has("buildingAddress") },
          attrs: {
            rows: "2",
            name: "buildingAddress",
            id: "buildingAddress",
            placeholder: _vm.$t(
              "message.service_request.big_cleaning_building_address_placeholder"
            )
          },
          domProps: { value: _vm.contactData.buildingAddress },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.contactData, "buildingAddress", $event.target.value)
            }
          }
        }),
        _vm._v(" "),
        _vm.errors.has("buildingAddress")
          ? _c("div", { staticClass: "mt-2 text-remark -status-alert" }, [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.$t("message.required_field")) +
                  "\n      "
              )
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "form-group" },
        [
          _c("label", { attrs: { for: "province_address" } }, [
            _vm._v(
              " " +
                _vm._s(
                  _vm.$t(
                    "message.service_request.big_cleaning_building_province"
                  )
                ) +
                " "
            ),
            _c("span", { staticClass: "text-danger" }, [_vm._v("*")])
          ]),
          _vm._v(" "),
          _c("v-select", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: "required",
                expression: "'required'"
              }
            ],
            ref: "province_address",
            class: { "form-alert": _vm.errors.has("province_address") },
            attrs: {
              options: _vm.provinces,
              placeholder: _vm.$t(
                "message.service_request.big_cleaning_building_require_province"
              ),
              label: "name_th",
              id: "province_address",
              name: "province_address",
              reduce: function(province) {
                return province.id
              },
              selectable: function(option) {
                return !(option.id == 0)
              }
            },
            on: { input: _vm.getDistricts },
            scopedSlots: _vm._u([
              {
                key: "option",
                fn: function(option) {
                  return [
                    _vm._v(
                      "\n          " + _vm._s(option.name_th) + "\n        "
                    )
                  ]
                }
              }
            ]),
            model: {
              value: _vm.contactData.province_id,
              callback: function($$v) {
                _vm.$set(_vm.contactData, "province_id", $$v)
              },
              expression: "contactData.province_id"
            }
          }),
          _vm._v(" "),
          _vm.errors.has("province_address")
            ? _c("div", { staticClass: "mt-2 text-remark -status-alert" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("message.required_field")) +
                    "\n      "
                )
              ])
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "form-group" },
        [
          _c("label", { attrs: { for: "district_address" } }, [
            _vm._v(
              " " +
                _vm._s(
                  _vm.$t(
                    "message.service_request.big_cleaning_building_district"
                  )
                ) +
                " "
            ),
            _c("span", { staticClass: "text-danger" }, [_vm._v("*")])
          ]),
          _vm._v(" "),
          _c("v-select", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: "required",
                expression: "'required'"
              }
            ],
            ref: "district_address",
            class: { "form-alert": _vm.errors.has("district_address") },
            attrs: {
              options: _vm.districts,
              placeholder: _vm.$t(
                "message.service_request.big_cleaning_building_require_district"
              ),
              label: "name_th",
              id: "district_address",
              name: "district_address",
              reduce: function(district) {
                return district.id
              },
              selectable: function(option) {
                return !(option.id == 0)
              }
            },
            on: { input: _vm.getSubDistricts },
            scopedSlots: _vm._u([
              {
                key: "option",
                fn: function(option) {
                  return [
                    _vm._v(
                      "\n          " + _vm._s(option.name_th) + "\n        "
                    )
                  ]
                }
              }
            ]),
            model: {
              value: _vm.contactData.district_id,
              callback: function($$v) {
                _vm.$set(_vm.contactData, "district_id", $$v)
              },
              expression: "contactData.district_id"
            }
          }),
          _vm._v(" "),
          _vm.errors.has("district_address")
            ? _c("div", { staticClass: "mt-2 text-remark -status-alert" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("message.required_field")) +
                    "\n      "
                )
              ])
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "form-group" },
        [
          _c("label", { attrs: { for: "sub_district_address" } }, [
            _vm._v(
              " " +
                _vm._s(
                  _vm.$t(
                    "message.service_request.big_cleaning_building_sub_district"
                  )
                )
            )
          ]),
          _vm._v(" "),
          _c("v-select", {
            ref: "sub_district_address",
            attrs: {
              options: _vm.subDistricts,
              placeholder: _vm.$t(
                "message.service_request.big_cleaning_building_require_sub_district"
              ),
              label: "name_th",
              id: "sub_district_address",
              name: "sub_district_address",
              reduce: function(sub_district) {
                return sub_district.id
              },
              selectable: function(option) {
                return !(option.id == 0)
              }
            },
            scopedSlots: _vm._u([
              {
                key: "option",
                fn: function(option) {
                  return [
                    _vm._v(
                      "\n          " + _vm._s(option.name_th) + "\n        "
                    )
                  ]
                }
              }
            ]),
            model: {
              value: _vm.contactData.sub_district_id,
              callback: function($$v) {
                _vm.$set(_vm.contactData, "sub_district_id", $$v)
              },
              expression: "contactData.sub_district_id"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        [
          _c("label", [
            _vm._v(
              _vm._s(
                _vm.$t("message.service_request.big_cleaning_attach_photos")
              )
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "text-remark mb-2" }, [
            _vm._v(
              _vm._s(
                _vm.$t(
                  "message.service_request.big_cleaning_attach_photos_remark"
                )
              ) + "\n      "
            )
          ]),
          _vm._v(" "),
          _c("vue-dropzone", {
            ref: "vueDropzone",
            staticClass: "dropzone-dashed",
            attrs: { id: "dropzone", options: _vm.dropzoneOptions }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "form-group mt-3" }, [
        _c("label", { attrs: { for: "remark" } }, [
          _vm._v(_vm._s(_vm.$t("message.service_request.big_cleaning_remark")))
        ]),
        _vm._v(" "),
        _c("textarea", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.contactData.remark,
              expression: "contactData.remark"
            }
          ],
          ref: "remark",
          staticClass: "form-control textarea-jumbo",
          attrs: {
            rows: "2",
            id: "remark",
            placeholder: _vm.textData.hintRemark
          },
          domProps: { value: _vm.contactData.remark },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.contactData, "remark", $event.target.value)
            }
          }
        })
      ]),
      _vm._v(" "),
      _vm._m(3),
      _vm._v(" "),
      _c("div", { staticClass: "my-4" }, [
        _c("label", { staticClass: "text-orange" }, [
          _vm._v(_vm._s(_vm.$t("message.service_request.remark")))
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "text-order-notification" }, [
          _vm._m(4),
          _vm._v(
            "\n        " +
              _vm._s(
                _vm.$t("message.service_request.service_request_remark01")
              ) +
              "\n      "
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "text-order-notification mt-3" }, [
          _vm._m(5),
          _vm._v(
            "\n        " +
              _vm._s(
                _vm.$t("message.service_request.service_request_remark02")
              ) +
              "\n      "
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "button button-block button-large -cyan",
          attrs: { disabled: _vm.isSubmitting },
          on: { click: _vm.validation }
        },
        [
          _vm._v(
            "\n      " +
              _vm._s(
                _vm.isSubmitting
                  ? _vm.$t("message.button.loading")
                  : _vm.$t("message.button.submit_request")
              ) +
              "\n    "
          )
        ]
      ),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      _c("div", { staticClass: "mt-4 mb-3 text-center" }, [
        _c("h3", [
          _vm._v(
            _vm._s(_vm.$t("message.big_cleaning.or_contact_customer_service"))
          )
        ]),
        _vm._v(" "),
        _vm._m(6)
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "bullet-notification -status-pending" }, [
      _c("i", { staticClass: "fas fa-circle" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "bullet-notification -status-pending" }, [
      _c("i", { staticClass: "fas fa-circle" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "bullet-notification -status-pending" }, [
      _c("i", { staticClass: "fas fa-circle" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mt-3" }, [_c("hr")])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "bullet-notification -status-pending" }, [
      _c("i", { staticClass: "fas fa-circle" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "bullet-notification -status-pending" }, [
      _c("i", { staticClass: "fas fa-circle" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "business-contact" }, [
      _c("div", { staticClass: "mb-3" }, [
        _c("i", { staticClass: "fas fa-phone-square text-primary" }),
        _vm._v(" "),
        _c("a", { attrs: { href: "tel:021131138" } }, [_vm._v("02-113-1138")])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "mb-3" }, [
        _c(
          "a",
          {
            attrs: {
              href: "https://line.me/R/ti/p/%40hnk7011n",
              target: "_blank"
            }
          },
          [_vm._v("\n            LINE ID: @BeNeat\n          ")]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "mt-3" }, [
        _c(
          "a",
          {
            attrs: {
              href: "https://line.me/R/ti/p/%40hnk7011n",
              target: "_blank"
            }
          },
          [
            _c("img", {
              attrs: {
                height: "38",
                alt: "Line BeNeat",
                src: "/static/img/btn-line.png"
              }
            })
          ]
        )
      ])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-72af0324", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-72af0324","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/serviceRequest/RequestForm.vue
// module id = 1548
// module chunks = 0